import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-xj",
  "use": "icon-xj-usage",
  "viewBox": "0 0 9 5",
  "content": "<symbol viewBox=\"0 0 9 5\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-xj\">\n    <title></title>\n    <g id=\"icon-xj_页面-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"icon-xj_上下箭头\" transform=\"translate(-138.000000, -113.000000)\" fill=\"#FF5D1B\" fill-rule=\"nonzero\">\n            <polygon id=\"icon-xj_路径备份-4\" points=\"138 113 147 113 142.499205 118\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol